module.exports = {"513323100":"章谷镇","513323101":"巴底镇","513323102":"革什扎镇","513323103":"东谷镇","513323104":"墨尔多山镇","513323105":"甲居镇","513323106":"格宗镇","513323107":"半扇门镇","513323108":"丹东镇","513323201":"巴旺乡","513323209":"梭坡乡","513323213":"太平桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513323.json
// module id = 2545
// module chunks = 0